import { t } from "i18next";
import BaseTable from "../../../common/base-table/base-table";


const getStatusText = status => {
    switch (status) {
        case 2:
            return "لغو شده"; // Canceled
        case 3:
            return "در حال استرداد"; // Refunding
        case 4:
            return "مسترد شده"; // Refunded
        case 5:
            return "در انتظار"; // Pending
        default:
            return "نامشخص"; // Unknown
    }
};

const getStatusStyle = status => {
    switch (status) {
        case 2: // Canceled
            return { color: "red" };
        case 3: // Refunding
            return { color: "orange" };
        case 4: // Refunded
            return { color: "green" };
        case 5: // Pending
            return { color: "blue" };
        default:
            return {};
    }
};

export default function CreditTable({ creditRefundRequestList, loading }) {
    const columns = [
        {
            accessorKey: "index",
            header: t("General.Row"),
            size: 80,
        },
        {
            accessorKey: "date",
            header: t("date"),
            Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString("fa-IR"),
        },
        {
            accessorKey: "amount",
            header: t("amount"),
            Cell: ({ cell }) => cell.getValue().toLocaleString() + " ریال",
        },
        {
            accessorKey: "status",
            header: t("status"),
            Cell: ({ cell }) => {
                const status = cell.getValue();
                return <span style={getStatusStyle(status)}>{getStatusText(status)}</span>;
            },
        },
        {
            accessorKey: "tracking_code",
            header: t("trackingCode"),
            Cell: ({ cell }) => cell.getValue() || "-",
        },
        {
            accessorKey: "description",
            header: t("description"),
            enableSorting: false,
            Cell: ({ cell }) => cell.getValue() || "-",
            size: 200,
        },
    ];

    const rows = creditRefundRequestList.map((item, index) => ({
        ...item,
        index: index + 1,
    }));

    return <BaseTable columns={columns} rows={rows} loading={loading} rowBackground="transparent" />;
}
